/* SillyFish — size guide
 * Turns the PDP's "size chart" text into a real button, opens the guide,
 * switches tabs, and highlights whichever size is selected on the page.
 */
(function () {
  var sg = document.getElementById('sf-sizeguide');
  if (!sg) return;

  var panel = sg.querySelector('.sf-sg__panel');
  var lastFocus = null;

  /* The PDP stores sizes as "4-5 years"; the table rows are "4-5". Strip the
     wording, the spaces and any dash variant so the two always compare. */
  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/–|—/g, '-')
      .replace(/years|year|yrs|yr/g, '')
      .replace(/[^0-9a-z-]/g, '');
  }

  function open() {
    lastFocus = document.activeElement;
    markSelectedSize();
    sg.classList.add('is-open');
    sg.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = sg.querySelector('.sf-sg__close');
    if (close) close.focus();
  }

  function close() {
    sg.classList.remove('is-open');
    sg.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function markSelectedSize() {
    var chosen = document.querySelector('.sfx-sz.sfx-on');
    var want = chosen ? norm(chosen.dataset.s || chosen.textContent) : '';
    var cells = sg.querySelectorAll('[data-sf-size]');
    for (var i = 0; i < cells.length; i++) {
      var on = want && norm(cells[i].getAttribute('data-sf-size')) === want;
      cells[i].classList.toggle('sf-sg__row--on', !!on);
      var tag = cells[i].querySelector('.sf-sg__tag');
      if (tag) tag.hidden = !on;
    }
  }

  /* Tabs */
  var tabs = sg.querySelectorAll('.sf-sg__tab');
  for (var t = 0; t < tabs.length; t++) {
    tabs[t].addEventListener('click', function (e) {
      var target = e.currentTarget.getAttribute('data-sf-tab');
      for (var i = 0; i < tabs.length; i++) {
        tabs[i].setAttribute('aria-selected', tabs[i].getAttribute('data-sf-tab') === target ? 'true' : 'false');
      }
      var panes = sg.querySelectorAll('.sf-sg__pane');
      for (var p = 0; p < panes.length; p++) {
        panes[p].hidden = panes[p].getAttribute('data-sf-pane') !== target;
      }
    });
  }

  /* Close */
  var closeBtn = sg.querySelector('.sf-sg__close');
  if (closeBtn) closeBtn.addEventListener('click', close);

  sg.addEventListener('click', function (e) {
    if (panel && !panel.contains(e.target)) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sg.classList.contains('is-open')) close();
  });

  /* Keep the highlight in step if the shopper changes size behind the guide. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.sfx-sz') : null;
    if (t) setTimeout(markSelectedSize, 0);
  });

  /* Build the trigger out of the PDP's existing "size chart" text. */
  function wireTrigger() {
    var explicit = document.querySelectorAll('[data-sf-sizeguide]');
    for (var i = 0; i < explicit.length; i++) {
      explicit[i].addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    }

    var notes = document.querySelectorAll('.sfx-lbl em');
    for (var n = 0; n < notes.length; n++) {
      var el = notes[n];
      if (el.querySelector('.sf-sg-open')) continue;
      var text = el.textContent || '';
      var idx = text.toLowerCase().indexOf('size chart');
      if (idx === -1) continue;

      var before = document.createTextNode(text.slice(0, idx));
      var after = document.createTextNode(text.slice(idx + 10));
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sf-sg-open';
      btn.textContent = text.substr(idx, 10);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });

      el.textContent = '';
      el.appendChild(before);
      el.appendChild(btn);
      el.appendChild(after);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireTrigger);
  } else {
    wireTrigger();
  }
})();